import { useCallback, useState } from "react";

/** 表单字段的错误文案，键是草稿字段。 */
export type Errors<D> = Partial<Record<keyof D, string>>;

/** 表单草稿：按字段更新，提交前整体换算成接口写入体。 */
export function useDraft<D extends object>(initial: D) {
  const [draft, setDraft] = useState(initial);
  const [errors, setErrors] = useState<Errors<D>>({});
  const set = useCallback(<K extends keyof D>(key: K, value: D[K]) => setDraft((d) => ({ ...d, [key]: value })), []);
  const reset = useCallback((next: D) => { setDraft(next); setErrors({}); }, []);
  return { draft, set, errors, setErrors, reset };
}
